import React, { useState } from 'react';
import {
  Box,
  Grid,
  TextField,
  Button,
  styled,
  Link,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Typography,
} from '@mui/material';
import NumberFormatCustom from '../common/form/NumberFormatCustom';
import BaseCodeSelectbox from '../common/form/selectbox/BaseCodeSelectbox';
import PartnerModalConatiner from '../../containers/common/form/modal/PartnerModalConatiner';

const FormLabel = styled(Box)(({ theme }) => ({
  //backgroundColor:'#ddd',
  ...theme.typography.subtitle2,
  borderRight: (theme) => `1px solid ${theme.palette.divider}`,
  textAlign: 'center',
}));

const ProductForm = ({ formik, makePrices }) => {
  const [openParnter, setOpenParnter] = useState(false);
  const handleOpen = () => {
    setOpenParnter(true);
  };
  const handleClose = () => {
    setOpenParnter(false);
  };

  const selectedPartner = (partner) => {
    formik.setFieldValue('partnerUuid', partner.partnerUuid);
    formik.setFieldValue('partnerNm', partner.partnerNm);
  };

  return (
    <div>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          mt: 1,
          px: 2,
        }}
      >
        <Grid
          container
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
          sx={{
            py: 1,
            borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
          }}
        >
          <Grid item xs={3}>
            <FormLabel>
              제조사
              <Typography
                variant="subtitle2"
                component="span"
                sx={{ mx: 1, color: 'error.main' }}
              >
                (필수)
              </Typography>
            </FormLabel>
          </Grid>
          <Grid item xs={7}>
            <TextField
              size="small"
              required={true}
              variant="outlined"
              disabled
              InputLabelProps={{ shrink: true }}
              fullWidth
              id="partnerNm"
              name="partnerNm"
              value={formik.values.partnerNm}
              error={
                formik.touched.partnerNm && Boolean(formik.errors.partnerNm)
              }
              helperText={formik.touched.partnerNm && formik.errors.partnerNm}
            />
          </Grid>
          <Grid item xs={1} textAlign="center">
            <Button
              color="secondary"
              variant="outlined"
              size="small"
              onClick={handleOpen}
            >
              제조사 선택
            </Button>
          </Grid>
          <Grid item xs={1} textAlign="center">
            <Button
              component={Link}
              color="warning"
              variant="outlined"
              size="small"
              target="_blank"
              rel="noopener noreferrer"
              href="/partnermng/add"
            >
              제조사 등록
            </Button>
          </Grid>
        </Grid>

        <Grid
          container
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
          sx={{
            py: 1,
            borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
          }}
        >
          <Grid item xs={3}>
            <FormLabel>
              제품군
              <Typography
                variant="subtitle2"
                component="span"
                sx={{ mx: 1, color: 'error.main' }}
              >
                (필수)
              </Typography>
            </FormLabel>
          </Grid>
          <Grid item xs={3}>
            <TextField
              size="small"
              variant="outlined"
              required
              fullWidth
              id="productLine"
              name="productLine"
              value={formik.values.productLine}
              onChange={formik.handleChange}
              error={
                formik.touched.productLine && Boolean(formik.errors.productLine)
              }
              helperText={
                formik.touched.productLine && formik.errors.productLine
              }
            />
          </Grid>
          <Grid item xs={3}>
            <FormLabel>
              분류 코드
              <Typography
                variant="subtitle2"
                component="span"
                sx={{ mx: 1, color: 'error.main' }}
              >
                (필수)
              </Typography>
            </FormLabel>
          </Grid>
          <Grid item xs={3}>
            <BaseCodeSelectbox
              formik={formik}
              filterObject={{
                blcCd: 'BASE',
                mlcCd: 'PRODUCT',
                slcCd: 'CATEGORY',
                useYn: 'Y',
              }}
              name="category"
              value={formik.values.category}
              size="small"
            />
          </Grid>
        </Grid>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
          sx={{
            py: 1,
            borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
          }}
        >
          <Grid item xs={3}>
            <FormLabel>
              제품명
              <Typography
                variant="subtitle2"
                component="span"
                sx={{ mx: 1, color: 'error.main' }}
              >
                (필수)
              </Typography>
            </FormLabel>
          </Grid>
          <Grid item xs={9}>
            <TextField
              size="small"
              variant="outlined"
              required
              fullWidth
              id="productNm"
              name="productNm"
              value={formik.values.productNm}
              onChange={formik.handleChange}
              error={
                formik.touched.productNm && Boolean(formik.errors.productNm)
              }
              helperText={formik.touched.productNm && formik.errors.productNm}
            />
          </Grid>
        </Grid>

        <Grid
          container
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
          sx={{
            py: 1,
            borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
          }}
        >
          <Grid item xs={3}>
            <FormLabel>
              제품 규격
              <Typography
                variant="subtitle2"
                component="span"
                sx={{ mx: 1, color: 'error.main' }}
              >
                (필수)
              </Typography>
            </FormLabel>
          </Grid>
          <Grid item xs={9}>
            <TextField
              size="small"
              variant="outlined"
              required
              fullWidth
              id="productSpec"
              name="productSpec"
              value={formik.values.productSpec}
              onChange={formik.handleChange}
              error={
                formik.touched.productSpec && Boolean(formik.errors.productSpec)
              }
              helperText={formik.touched.productSpec && formik.errors.productSpec}
            />
          </Grid>
        </Grid>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
          sx={{
            py: 1,
            borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
          }}
        >
          <Grid item xs={3}>
            <FormLabel>
              매입 가격
              <Typography
                variant="subtitle2"
                component="span"
                sx={{ mx: 1, color: 'error.main' }}
              >
                (필수)
              </Typography>
            </FormLabel>
          </Grid>
          <Grid item xs={3}>
            <TextField
              size="small"
              variant="outlined"
              required
              fullWidth
              id="price"
              name="price"
              value={formik.values.price}
              onChange={(e) => formik.setFieldValue('price', e.target.value)}
              error={formik.touched.price && Boolean(formik.errors.price)}
              helperText={formik.touched.price && formik.errors.price}
              InputProps={{
                inputComponent: NumberFormatCustom,
              }}
            />
          </Grid>
          <Grid item xs={3}>
            <FormLabel>
              소비자 가격
              <Typography
                variant="subtitle2"
                component="span"
                sx={{ mx: 1, color: 'error.main' }}
              ></Typography>
            </FormLabel>
          </Grid>
          <Grid item xs={3}>
            <TextField
              size="small"
              variant="outlined"
              required
              fullWidth
              id="priceConsume"
              name="priceConsume"
              value={formik.values.priceConsume}
              onChange={(e) =>
                formik.setFieldValue('priceConsume', e.target.value)
              }
              error={
                formik.touched.priceConsume &&
                Boolean(formik.errors.priceConsume)
              }
              helperText={
                formik.touched.priceConsume && formik.errors.priceConsume
              }
              InputProps={{
                inputComponent: NumberFormatCustom,
              }}
            />
          </Grid>
        </Grid>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
          sx={{
            py: 1,
            borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
          }}
        >
          <Grid item xs={3}>
            <FormLabel>단위</FormLabel>
          </Grid>
          <Grid item xs={9}>
            <TextField
              size="small"
              variant="outlined"
              fullWidth
              id="productUnit"
              name="productUnit"
              value={formik.values.productUnit}
              onChange={formik.handleChange}
              error={
                formik.touched.productUnit && Boolean(formik.errors.productUnit)
              }
              helperText={
                formik.touched.productUnit && formik.errors.productUnit
              }
            />
          </Grid>
        </Grid>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
          sx={{
            py: 1,
            borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
          }}
        >
          <Grid item xs={3}>
            <FormLabel>사양</FormLabel>
          </Grid>
          <Grid item xs={9}>
            <TextField
              margin="normal"
              variant="outlined"
              fullWidth
              multiline
              rows={5}
              id="productDesc"
              name="productDesc"
              value={formik.values.productDesc}
              onChange={formik.handleChange}
              error={
                formik.touched.productDesc && Boolean(formik.errors.productDesc)
              }
              helperText={
                formik.touched.productDesc && formik.errors.productDesc
              }
            />
          </Grid>
        </Grid>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
          sx={{ py: 1 }}
        >
          <Grid item xs={3}>
            <FormLabel>사용</FormLabel>
          </Grid>
          <Grid item xs={9}>
            <FormGroup>
              <FormControlLabel
                id="useYn"
                name="useYn"
                label="사용"
                control={
                  <Checkbox
                    checked={formik.values.useYn}
                    onChange={formik.handleChange}
                  />
                }
              />
            </FormGroup>
          </Grid>
        </Grid>
      </Box>
      {openParnter && (
        <PartnerModalConatiner
          link
          title="제조사 선택"
          open={openParnter}
          handleClose={handleClose}
          selectedPartner={selectedPartner}
        />
      )}
    </div>
  );
};

export default ProductForm;
